
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/unit.js';
            vueApps['app/unit.js'] = App0;
        

            import App1 from './app/LastViewedUnits.js';
            vueApps['app/LastViewedUnits.js'] = App1;
        

            import App2 from './app/dummy.js';
            vueApps['app/dummy.js'] = App2;
        

            import App3 from './app/navbar.js';
            vueApps['app/navbar.js'] = App3;
        

            import App4 from './app/search.js';
            vueApps['app/search.js'] = App4;
        

            import App5 from './app/facility.js';
            vueApps['app/facility.js'] = App5;
        

            import App6 from './app/urlaubmithund.js';
            vueApps['app/urlaubmithund.js'] = App6;
        

            import App7 from './app/UnitsWithSauna.js';
            vueApps['app/UnitsWithSauna.js'] = App7;
        

            import App8 from './app/indexMap.js';
            vueApps['app/indexMap.js'] = App8;
        

            import App9 from './app/UnitsOfTheDay.js';
            vueApps['app/UnitsOfTheDay.js'] = App9;
        

            import App10 from './app/UnitsForFamily.js';
            vueApps['app/UnitsForFamily.js'] = App10;
        

            import App11 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App11;
        

            import App12 from './app/kleinkindfreundliche.js';
            vueApps['app/kleinkindfreundliche.js'] = App12;
        

            import App13 from './app/seniorengerechterUrlaub.js';
            vueApps['app/seniorengerechterUrlaub.js'] = App13;
        

            import App14 from './app/ferienwohnungDarss.js';
            vueApps['app/ferienwohnungDarss.js'] = App14;
        

            import App15 from './app/ferienhausDarss.js';
            vueApps['app/ferienhausDarss.js'] = App15;
        

            import App16 from './app/landingpagePrerow.js';
            vueApps['app/landingpagePrerow.js'] = App16;
        

            import App17 from './app/landingpageZingst.js';
            vueApps['app/landingpageZingst.js'] = App17;
        

            import App18 from './app/landingpageFuhlendorf.js';
            vueApps['app/landingpageFuhlendorf.js'] = App18;
        

            import App19 from './app/UnitsFerienhausGarten.js';
            vueApps['app/UnitsFerienhausGarten.js'] = App19;
        

            import App20 from './app/UnitsFerienunterkunftSauna.js';
            vueApps['app/UnitsFerienunterkunftSauna.js'] = App20;
        

            import App21 from './app/UnitsFerienhauserZingst.js';
            vueApps['app/UnitsFerienhauserZingst.js'] = App21;
        

            import App22 from './app/UnitsStrandurlaubZingst.js';
            vueApps['app/UnitsStrandurlaubZingst.js'] = App22;
        

            import App23 from './app/UnitsFerienwohnungenZingst.js';
            vueApps['app/UnitsFerienwohnungenZingst.js'] = App23;
        

            import App24 from './app/landingpageBresewitz.js';
            vueApps['app/landingpageBresewitz.js'] = App24;
        

        
                import Comp25 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp25);
            

                import Comp26 from './comp/ImgFallback2.vue';
                Vue.component('img-fallback2',Comp26);
            

                import Comp27 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp27);
            

                import Comp28 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp28);
            

                import Comp29 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp29);
            

                import Comp30 from './offershelp.vue';
                Vue.component('offer-help',Comp30);
            

                import Comp31 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp31);
            

                import Comp32 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp32);
            

                import Comp33 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp33);
            

                import Comp34 from './comp/searchUnitByName.vue';
                Vue.component('search-unit-name',Comp34);
            

                import Comp35 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp35);
            

                import Comp36 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp36);
            

                import Comp37 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp37);
            

                import Comp38 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp38);
            

                import Comp39 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp39);
            

                import Comp40 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp40);
            

                import Comp41 from './teamMember.vue';
                Vue.component('voffice-team-member',Comp41);
            

                import Comp42 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp42);
            

                import Comp43 from './cancellationPolicy.vue';
                Vue.component('cancellationpolicy',Comp43);
            

                import Comp44 from './videoIframe.vue';
                Vue.component('video-iframe',Comp44);
            

                import Comp45 from './comp/Voucher-Search.vue';
                Vue.component('voffice-voucher-search',Comp45);
            

                import Comp46 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp46);
            

                import Comp47 from './comp/childrenage.vue';
                Vue.component('childrenage',Comp47);
            

                import Comp48 from './comp/Voucher-Unit.vue';
                Vue.component('voffice-voucher-unit',Comp48);
            

                import Comp49 from './comp/PopupDialog.vue';
                Vue.component('voffice-popup-dlg',Comp49);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    